module.exports = __webpack_public_path__ + "static/media/trolls.c297d0be.png";